import {useQueryClient} from '@tanstack/react-query';
import {createApiQuery, useApiMutation} from './api';
import {
  SaveTag,
  DeleteTag,
  GetTags,
  GetTagsWithDetails,
} from '../../shared/api/definitions/tags';

const TagQueryKeys = {
  all: ['tags'] as const,
  list: () => [...TagQueryKeys.all, 'list'],
  details: () => [...TagQueryKeys.all, 'details'],
};

export const useTags = createApiQuery(GetTags, () => TagQueryKeys.list());

export const useGetTagsWithDetails = createApiQuery(GetTagsWithDetails, () =>
  TagQueryKeys.details()
);

export const useSaveTagMutation = () => {
  const queryClient = useQueryClient();
  return useApiMutation(SaveTag, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TagQueryKeys.all,
      });
    },
  });
};

export const useDeleteTagMutation = () => {
  const queryClient = useQueryClient();
  return useApiMutation(DeleteTag, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TagQueryKeys.all,
      });
    },
  });
};
